import emailjs from '@emailjs/browser';

// Initialize EmailJS with your public key
emailjs.init("qwHR6pzKEOt4vcOdM");

// Template pour le formulaire de devis
export const sendDevisEmail = async (data: any) => {
  try {
    const templateParams = {
      client_type: data.clientType || '',
      services: Array.isArray(data.diagnostics) ? data.diagnostics.join(", ") : '',
      project_type: data.projectType || '',
      construction_year: data.constructionYear || '',
      surface: data.surface || '',
      urgency: data.urgency || '',
      name: data.name || '',
      email: data.email || '',
      phone: data.phone || '',
      address: data.address || '',
      message: data.message || '',
      preferred_date: data.preferredDate || ''
    };

    const response = await emailjs.send(
      "service_emcgjo5",
      "template_frl54ap",
      templateParams
    );

    return response;
  } catch (error) {
    console.error("Erreur lors de l'envoi du devis:", error);
    throw error;
  }
};

// Template pour le formulaire de contact
export const sendContactEmail = async (data: any) => {
  try {
    const templateParams = {
      name: data.name || '',
      email: data.email || '',
      phone: data.phone || '',
      subject: data.subject || '',
      message: data.message || '',
      preferred_date: data.preferredDate || ''
    };

    const response = await emailjs.send(
      "service_emcgjo5",
      "template_yq7whgh",
      templateParams
    );

    return response;
  } catch (error) {
    console.error("Erreur lors de l'envoi du message:", error);
    throw error;
  }
};